import React from 'react'
import { Image, View, useTheme } from '@aws-amplify/ui-react'
import Logo from '../../../assets/images/npm-logo-blue.png'

export const Header = () => {
  const { tokens } = useTheme()

  return (
    <View textAlign="center" marginBottom={tokens.space.xl}>
      <Image alt="NPM Logo" src={Logo} height={100} />
    </View>
  )
}
